import script from "./UBreadcrumbs.vue?vue&type=script&setup=true&lang=ts"
export * from "./UBreadcrumbs.vue?vue&type=script&setup=true&lang=ts"

import "./UBreadcrumbs.vue?vue&type=style&index=0&id=04cdb21e&lang=scss"

const __exports__ = script;

export default __exports__